import {FC} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {SectionLayout} from '../common/content/SectionLayout'

type ServiceRequestTilesProps = {
  title: string
  subtitle?: string
  maxWidth?: string
  titleMaxWidth?: string
}

export const ServiceRequestTiles: FC<React.PropsWithChildren<ServiceRequestTilesProps>> = ({
  title,
  subtitle,
  maxWidth = '850px',
  titleMaxWidth,
  children,
}) => {
  return (
    <>
      <SectionLayout
        title={{text: title, maxWidth: titleMaxWidth}}
        description={subtitle ? {text: subtitle} : undefined}
        maxWidth={maxWidth}
      >
        <ul className="list">{children}</ul>
      </SectionLayout>

      <style jsx>{`
        .list {
          display: flex;
          justify-content: space-between;
          margin: 0 -${theme.spacing[3]};
        }
        @media ${TABLET_SCREENSIZE} {
          .list {
            flex-wrap: wrap;
            justify-content: center;
            margin: ${theme.spacing[2]} auto 0;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .list {
            margin-top: 0;
            display: block;
          }
        }
      `}</style>
    </>
  )
}
